import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api';
import { CompanyType, type Company } from '@/features/companies/types';

export const companiesQuery = (organizationId: string, type = CompanyType.CLIENT) =>
  queryOptions({
    queryKey: ['companies', organizationId, type],
    queryFn: async () =>
      (
        await api.get<Company[]>(`v1/organizations/${organizationId}/companies`, {
          params: { type },
        })
      ).data,
  });
